export { default } from './DigitalItemInfo';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/DigitalItemInfo/index.js